import React from 'react';   
import axios from 'axios';
import * as utils from '../../utils';
import * as apis from '../../constants/Apis';
import LoadingPage from '../../components/Layout/LoadingPage'; 
import DataTable from '../../components/DataTable';
import {Link} from 'react-router-dom';
import {ToastContainer} from 'react-toastr'
import '../../assets/css/toastr.css';

class History extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            showLoading: false,
            data: [],
            meta: {
                perPage: 10,
                currentPage: 1
            }
        }
    }

    changeMeta(meta){
        this.setState({meta})
    }

    componentDidMount(){
        const {t}= this.props
        let _this = this;
        this.setState({showLoading: true})
        let config = utils.getConfig();
        axios.get(apis.BASE_URL + 'users/' + utils.getUserId() + '/billing-history', config)
        .then( res => {
            _this.setState({
                data: res.data.items,
                showLoading: false
            });
        })
        .catch( error => {
            this.setState({showLoading: false});
            _this.refs.toastContainer.error(t("Can not get project list"));
        });        
    }

    render(){
        const { t } = this.props
        let {meta, data, showLoading} = this.state,
        invoiceNumber = "",
        config = {
            api: false,
            sortDefault :{
                property: "invoiceDate",
                direction: "DESC"
            },
            cols: [
                { property: "invoiceNumber",
                    sortable: false,
                    display :"none",
                    renderer : value => {
                        invoiceNumber = value
                    }
                },
                { property: "amount", header: t("Decription"), 
                    sortable: false,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => {
                        if(value !== 0){
                            return t("Invoice") + " #" + invoiceNumber
                        }
                        else{
                            return t("Add Credit")
                        } 
                    }
                },
                { property: "invoiceDate", header: t("Invoice Date"),
                    sortable: false,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => value ? value : t("(not set)")
                },
                { property: "amount", header: t("Amount"),
                    sortable: false,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => <span className="m--font-bold"> ${value}</span>
                },                
                { property: "creditAdj", header: t("Credit Adjustment"),
                    sortable: false,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => <span className="m--font-bold"> ${value}</span>
                },
                { property: "balance", header: t("Balance"), 
                    sortable: false,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value =>'$'+value
                },
                { property: "invoiceId", header: t(""),
                    sortable: false,    
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => {return(<Link to={{pathname: "/detail-payment",
                                                        search: "?Iv="+value,
                                                        state: { projectId: value}
                                                      }} className="btn btn-outline-info m-btn m-btn--custom m-btn--icon m-btn--air">
                                                    <span>
                                                        <i className="fa fa-file-excel-o"></i>
                                                        <span>{t('Detail')}</span>
                                                    </span>
                                                </Link>);}
                },
            ]
        }
        
        return(
            <div>
                {showLoading && <LoadingPage />}
                <DataTable datasource={data} 
                config={config} 
                meta={meta} 
                changeMeta= {this.changeMeta.bind(this)}
                t = {t}/>
                <ToastContainer ref = "toastContainer" className="toast-top-right"/>
            </div>
        );
    }
}

export default History;